const apiUrl = window.config.api.gateway.general;
const { sbaseUrl } = URL;
import { URLS } from "fire-wind-water/index";

const isSetting = Number(URLS.getURL("isSetting"));
window.$sk.setApiUrl(apiUrl);
window.$sk.setUploadUrl(sbaseUrl);
import { of } from "rxjs";
import fileInfo from "./mock/pc/file";
import serverTime from "./mock/pc/webinarOpenGetServerTime";
import seminarInfo from "./mock/pc/seminarTopicTemplateSeminarGet";
import newsInfo from "./mock/pc/news";
import partnerInfo from "./mock/pc/partner";

export default {
  //获取服务器时间
  getServerTime: () => {
    if (isSetting === 1) {
      return of({ content: serverTime.content });
    } else {
      return of({ content: Date.parse(new Date()) / 1000 });
      //TODO 这里获取时间的接口不同
      //return window.$sk.$skxhr("webinar/open/getServerTime");
    }
  },
  //浏览记录
  seminarSiteBrowse: (params) => {
    return window.$sk.$skxhr("api/seminar/site/browse", params);
  },

  //获取报名消息
  canRegisterNew: (params) => {
    return window.$sk.$skxhr("seminar/register/canRegisterNew", params);
  },
  previewFile: (params) => {
    return window.$sk.$skxhr("api/file/interaction/preview", params);
  },
  //api/file/interaction/preview
  //获取短地址
  getShortUrl: (params) => {
    return window.$sk.$skxhr("shortUrl/getList", params);
  },
  //获取用户信息
  getMyInfo: (params) => {
    return window.$sk.$skxhr("api/member/contacts/info/get", params);
  },
  getTopicTemplateSeminar: (params) => {
    return window.$sk.$skxhr("seminar/topicTemplate/seminar/get", params);
  },
  getInstanceUrl: (params) => {
    return window.$sk.$skxhr("template/platform/instance/getUrl", params);
  },
  getFileList: (params) => {
    if (isSetting === 1) {
      return of({ content: fileInfo.content });
    }
    return window.$sk.$skxhr("api/file/all/query", params);
  },
  getArticleList: (params) => {
    if (isSetting === 1) {
      if (params.type === "news") {
        return of({ content: newsInfo.content });
      } else {
        return of({ content: partnerInfo.content });
      }
    }
    return window.$sk.$skxhr("api/article/all/query", params);
  },
  getInstanceStatus: (params) => {
    return window.$sk.$skxhr("template/platform/instance/getStatus", params);
  },
  getSeminarContactInfo: (params) => {
    return window.$sk.$skxhr("api/seminar/contacts/get", params);
  },
  getDownloadWithEmail: (params) => {
    return window.$sk.$skxhr("file/downloadWithEmail", params);
  },
  getDownloadFile: (params) => {
    return window.$sk.$skxhr("file/downloadFile", params);
  },
  getSeminarInfo: (params) => {
    if (isSetting === 1) {
      return of({ content: seminarInfo.content });
    }
    return window.$sk.$skxhr("seminar/topicTemplate/seminar/get", params);
  },
  //获取模板配置
  getTemplateConfig: (params) => {
    return window.$sk.$skxhr("template/platform/instance/getConfig", params);
  },
  getDomain(tenantId) {
    return window.$sk.$skxhr("api/domain/GetDomain", { tenantId: tenantId });
  },
  hasparticipation(params) {
    return window.$sk.$skxhr("api/questionnaire/hasparticipation", params);
  },
  getDefaultQestion(params) {
    return window.$sk.$skxhr("api/seminar/tools/getDefault", params);
  },
  getFormNewRegister(params) {
    return window.$sk.$skxhrp("api/member/form/get", params);
  },
};
